import Cookies from 'js-cookie'

const TokenKey = 'token'
const UserInfoKey = 'user-info'

export function getToken() {
    return localStorage.getItem(TokenKey)
}

export function setToken(token) {
    return localStorage.setItem(TokenKey, token)
}

export function removeToken() {
    localStorage.removeItem(TokenKey)
    return Cookies.remove(TokenKey)
}

export const getUserInfo = () => {
    return Cookies.get(UserInfoKey)
}

export const setUserInfo = (userInfo) => {
    Cookies.remove(UserInfoKey)
    localStorage.removeItem(UserInfoKey)
    localStorage.setItem(UserInfoKey, JSON.stringify(userInfo))
    return Cookies.set(UserInfoKey, userInfo)
}

export const removeUserInfo = () => {
    return Cookies.remove(UserInfoKey)
}




// WEBPACK FOOTER //
// ./src/common/js/auth.js